import CommonServices from '@/services/Common/CommonServices'; // FIXME: for some reason if we import from `@/services/Common` or `@services/Common/CommonServicesMock`, unit test fails for every other components test files (saying mockNavigation.json file has issue)
import { setQueryString, getQueryString } from '@/utils/UrlUtils';
import { CLICK_OUTSIDE } from '@general/js/_customDirectives';
import StatusCodeEnums from '@general/js/services/Services';

const apiTimeoutTime = 500;
let triggerSearchSuggestion;

export default {
  directives: {
    'click-outside': CLICK_OUTSIDE,
  },

  data() {
    return {
      searchTerm: '',
      suggestions: [],
      showSuggestions: false,
      results: {},
      resultTotalNum: NaN,
      pageNum: 1,
      loading: true,
      searchNotFound: false,
      searchError: false,
      paginationEndPage: NaN,
      defaultPageSize: 10,
    };
  },

  watch: {
    searchTerm() {
      this.suggestions = [];
      this.searchSuggestion();
    },
  },

  methods: {
    getQueryString,

    suggestionVisible(bool) {
      this.showSuggestions = bool;
    },

    async searchSuggestion() {
      this.suggestionVisible(true);
      clearTimeout(triggerSearchSuggestion);

      triggerSearchSuggestion = setTimeout(async () => {
        try {
          if (this.searchTerm !== '') {
            this.suggestions = await CommonServices.getSearchPrediction(this.searchTerm);
          }
        } catch (err) {
          logger.log(err);
        }
      }, apiTimeoutTime);
    },

    async search(searchTerm, pageNum = this.pageNum) {
      let thisPageNum = pageNum;

      this.suggestionVisible(false);
      this.suggestions = [];
      this.searchTerm = searchTerm;
      this.loading = true;
      this.searchNotFound = false;
      this.searchError = false;

      setQueryString('searchText', searchTerm);

      if (this.searchedTerm !== searchTerm) {
        thisPageNum = 1;
        this.pageNum = thisPageNum;
        this.results = {};
        setQueryString('pageNum', thisPageNum);
      }

      try {
        const res = await CommonServices.getSearchResults(encodeURI(this.searchTerm), thisPageNum, this.defaultPageSize);

        this.results[`page${thisPageNum}`] = res.results;
        this.resultTotalNum = res.totalNum;
        this.paginationEndPage = Math.ceil(res.totalNum / this.defaultPageSize);
      } catch (error) {
        logger.log(error);

        // check error status
        if (StatusCodeEnums.API_ERROR_STATUS_CODES.NOT_FOUND.includes(error.statusCode)) {
          this.searchNotFound = true;
        } else {
          this.searchError = true;
        }
      } finally {
        this.loading = false;
        this.searchedTerm = searchTerm;
      }
    },
  },
};
